<template>
	<div class="tw-flex tw-gap-2">
		<AppButton
			:label="$t('products.auto-link-products')"
			@click="$router.push('/v2/products/auto-link')"
			secondary
			variant="gray"
		/>
		<div class="tw-w-fit" v-if="!loading && (canCreateProduct || $can('products.import'))">
			<AppMenu>
				<template #trigger>
					<AppButton
						:label="$t('products.add-product')"
						startIcon="assets/v2/image/icons/plus.svg"
					/>
				</template>
				<div class="tw-flex tw-flex-col tw-p-2">
					<button :title="$unauthorizedMessage('products.create')" :disabled="!canCreateProduct" :class="{ '!tw-cursor-not-allowed tw-opacity-50': !canCreateProduct }" class="tw-cursor-pointer tw-p-2 tw-text-start hover:tw-bg-gray-50" @click="openManualAdd">
						{{ $t('products.manual-add') }}
					</button>
					<button :title="$unauthorizedMessage('products.import')" :disabled="$cannot('products.import')" :class="{ '!tw-cursor-not-allowed tw-opacity-50': $cannot('products.import') }" class="tw-cursor-pointer tw-text-start tw-p-2 hover:tw-bg-gray-50" @click="openViaExcel">
						{{ $t('products.add-via-excel') }}
					</button>
				</div>
			</AppMenu>
		</div>
		<div v-else-if="loading">
			<AppSkeleton width="120px" height="38px" type="input" />
		</div>
	</div>
</template>

<script setup>
import AppMenu from '@/v2/components/app-menu.vue';
import { useRouter } from 'vue-router';
import { abilities, useLimitationsStore } from '@/v2/modules/products/stores/limitations';
import { ref } from 'vue';
import { ProductsModulePolicy } from '../../../policy';
import AppSkeleton from '@/v2/components/skeleton.vue';
import { useProductEditorStore } from '../../../stores/product-editor'; 

const router = useRouter();
const limitationStore = useLimitationsStore();
const productEditorStore = useProductEditorStore()

const openManualAdd = async () => {
	limitationStore.checkLimitation(abilities.CreateProduct).then(() => {
		router.push('/v2/products/create');
	});
};

const openViaExcel = () => {
	router.push('/v2/imports/create/import-products-complete');
};

const loading = ref(true)
const canCreateProduct = ref(false)

async function checkCanCreateProduct() {
	loading.value = true;
	try {
		await productEditorStore.fetchLinkedMarketplaces()
		canCreateProduct.value = await ProductsModulePolicy.canCreateProduct(productEditorStore.linkedMarketplacesList.map(({id}) => id))
	} finally {
		loading.value = false
	}
}

checkCanCreateProduct()
</script>

<style lang="scss" scoped></style>
